import { useState } from 'react';
import { PersonalInfoContent, type PersonalInfoFormValues } from '../personal-info-content';
import { TelehealthRequestContent, type TelehealthRequestFormValues } from '../telehealth-request-content';
import { TelehealthRequestNoticeContent } from '../telehealth-request-notice-content';
import type { TelehealthRequestStep } from '../TelehealthRequestStepsModal';

type P = {
  onClose: () => void;
  setStep: (step: TelehealthRequestStep) => void;
  step: TelehealthRequestStep;
};

const Steps = ({ onClose, setStep, step }: P) => {
  const [telehealthRequestPersonalInfoFormValues, setTelehealthRequestPersonalInfoFormValues] =
    useState<Partial<PersonalInfoFormValues>>();
  const [telehealthRequestFormValues, setTelehealthRequestFormValues] =
    useState<Partial<TelehealthRequestFormValues>>();

  switch (step) {
    case 'notice':
      return (
        <TelehealthRequestNoticeContent
          onClose={onClose}
          onSubmit={() => {
            setStep('personal-form');
          }}
        />
      );

    case 'personal-form':
      return (
        <PersonalInfoContent
          initialFormValues={telehealthRequestPersonalInfoFormValues}
          onBack={(formValues: Partial<PersonalInfoFormValues>) => {
            setStep('notice');
            setTelehealthRequestPersonalInfoFormValues(formValues);
          }}
          onSuccess={() => {
            setTelehealthRequestPersonalInfoFormValues(undefined);
            setStep('telehealth-form');
          }}
        />
      );

    case 'telehealth-form':
      return (
        <TelehealthRequestContent
          initialFormValues={telehealthRequestFormValues}
          onBack={(formValues: Partial<TelehealthRequestFormValues>) => {
            setStep('personal-form');
            setTelehealthRequestFormValues(formValues);
          }}
          onSuccess={onClose}
        />
      );
  }
};

export default Steps;
